import React, { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import NaviBarv2 from "./Components/NaviBarv2";
import Footer from "./Components/Footer";
import { Container, Row, Col, Card, Badge, Button, Form } from "react-bootstrap";

const ACCENT = "#198754";

const numStyle = (branch) => ({
  width: 34,
  height: 34,
  borderRadius: "50%",
  background: branch ? "#b5720c" : ACCENT,
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 14,
  marginBottom: 10,
});

// Процесс получения экспертного заключения (ЭЗ)
const EZ_STEPS = [
  {
    n: 1,
    deadline: "За 15 раб. дней",
    title: "Заполнить",
    text: "форму авторской справки (см. генератор ниже)",
  },
  {
    n: 2,
    title: "Отправить в ЦИСПТ",
    text:
      "материалы в Word, реферат на рус.яз. (если материал на иностр.), скан подписанной справки — на email ЦИСПТ evseeva.ev@talantiuspeh.ru",
  },
  {
    n: 3,
    title: "Отнести",
    text: "распечатанные материалы и оригинал справки — 3 этаж, каб. М15",
  },
  {
    n: 4,
    title: "Экспертиза",
    text: "подписание ЭЗ у членов Комиссии (КВЭК)",
  },
  {
    n: 5,
    branch: true,
    title: "При разногласии",
    text: "материалы направляются на внешнюю экспертизу",
  },
  {
    n: 6,
    title: "Утверждение ЭЗ",
    text:
      "скан ЭЗ ЦИСПТ направляет автору по почте; оригинал забирать в каб. М15",
  },
];

const PURPOSE_DETAIL_LABEL = {
  журнал: "Название журнала",
  конференция: "Название конференции",
  диссовет: "Название диссертационного совета",
  иное: "Уточнение назначения",
};

const PURPOSE_TEXT = {
  журнал: "опубликования в журнале",
  конференция: "опубликования в сборнике тезисов конференции",
  диссовет: "представления к защите в диссертационный совет",
  иное: "представления",
};

const MONTHS = [
  "января", "февраля", "марта", "апреля", "мая", "июня",
  "июля", "августа", "сентября", "октября", "ноября", "декабря",
];

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])
  );
}

function fill(value, placeholder) {
  if (value && value !== "") {
    return '<span class="ez-fill">' + escapeHtml(value) + "</span>";
  }
  return '<span class="ez-empty">' + escapeHtml(placeholder) + "</span>";
}

// Печать/сохранение в PDF через скрытый iframe (без всплывающего окна — не
// блокируется, работает быстрее). @page { margin: 0 } убирает служебные
// колонтитулы браузера (дата, about:blank, номер страницы); отступы задаются
// через padding у body.
function printHtml(content) {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  const frameWin = iframe.contentWindow;
  const frameDoc = frameWin.document;
  frameDoc.open();
  frameDoc.write(
    '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Авторская справка</title><style>' +
      "@page{size:A4;margin:0;}" +
      "*{margin:0;padding:0;box-sizing:border-box;}" +
      'body{font-family:Georgia,"Times New Roman",serif;font-size:14px;line-height:1.8;color:#1a1a1a;padding:1.5cm 2cm;background:#fff;}' +
      ".ez-title{text-align:center;font-weight:700;font-size:16px;margin-bottom:20px;}" +
      "p{margin:0 0 14px 0;text-align:justify;}" +
      ".ez-sign-line{display:flex;justify-content:space-between;margin-top:15px;}" +
      ".ez-sign-label{font-size:11px;color:#777;margin-top:2px;}" +
      ".ez-fill{border-bottom:1px solid #666;padding:0 4px;font-weight:500;}" +
      ".ez-empty{border-bottom:1px solid #999;padding:0 4px;color:#b8382f;}" +
      "</style></head><body>" +
      content +
      "</body></html>"
  );
  frameDoc.close();

  // Chrome берёт имя файла для «Сохранить как PDF» из document.title верхней
  // страницы (даже при печати iframe). На время печати подменяем заголовок,
  // затем возвращаем прежний.
  const prevTitle = document.title;
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    document.title = prevTitle;
    window.removeEventListener("afterprint", finish);
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
  };

  const runPrint = () => {
    document.title = "Авторская справка";
    window.addEventListener("afterprint", finish);
    frameWin.onafterprint = finish;
    frameWin.focus();
    frameWin.print();
    // Подстраховка, если браузер не пришлёт afterprint.
    setTimeout(finish, 60000);
  };

  if (frameDoc.readyState === "complete") {
    setTimeout(runPrint, 100);
  } else {
    frameWin.onload = () => setTimeout(runPrint, 100);
  }
}

// Ленивая подгрузка библиотеки docx (UMD) с CDN — только при первом клике по
// «Скачать .docx». Библиотека кладёт себя в window.docx.
let docxLibPromise = null;
function ensureDocx() {
  if (window.docx) return Promise.resolve(window.docx);
  if (docxLibPromise) return docxLibPromise;
  docxLibPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://cdn.jsdelivr.net/npm/docx@8.5.0/build/index.umd.js";
    s.async = true;
    s.onload = () =>
      window.docx ? resolve(window.docx) : reject(new Error("docx недоступен"));
    s.onerror = () => {
      docxLibPromise = null;
      reject(new Error("Не удалось загрузить библиотеку docx"));
    };
    document.head.appendChild(s);
  });
  return docxLibPromise;
}

function ExpertReview() {
  const [fio, setFio] = useState("");
  const [isStudent, setIsStudent] = useState(false);
  const [supervisorFio, setSupervisorFio] = useState("");
  const [materialType, setMaterialType] = useState("статьи");
  const [pages, setPages] = useState("");
  const [titleRu, setTitleRu] = useState("");
  const [isForeign, setIsForeign] = useState(false);
  const [titleEn, setTitleEn] = useState("");
  const [purposeType, setPurposeType] = useState("журнал");
  const [purposeDetail, setPurposeDetail] = useState("");
  const [publisher, setPublisher] = useState("");
  const [signDate, setSignDate] = useState("");
  const [docHtml, setDocHtml] = useState("");

  const docRef = useRef(null);

  // Единый вывод вычисляемых полей — используется и предпросмотром, и .docx,
  // чтобы они всегда совпадали.
  function deriveFields() {
    let titleText = titleRu ? "«" + titleRu + "»" : "";
    if (isForeign && titleEn) {
      titleText += " (" + titleEn + ")";
    }
    const fullMaterial = [materialType, titleText].filter(Boolean).join(" ");

    const purposeText = PURPOSE_TEXT[purposeType] || "";
    let fullPurpose = purposeText;
    if (purposeDetail) fullPurpose += " " + purposeDetail;
    if (purposeType === "журнал" && publisher) {
      fullPurpose += " (издательство: " + publisher + ")";
    }

    let dateStr = "";
    if (signDate) {
      const d = new Date(signDate + "T00:00:00");
      if (!isNaN(d.getTime())) {
        dateStr =
          d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear() + " г.";
      }
    }
    return { fullMaterial, fullPurpose, dateStr };
  }

  function buildDoc() {
    const { fullMaterial, fullPurpose, dateStr } = deriveFields();

    let html = '<div class="ez-title">Авторская справка</div>';
    html +=
      "<p>Я, " +
      fill(fio, "Ф.И.О. автора") +
      ", автор " +
      fill(fullMaterial, "вид и название материалов") +
      "</p>";
    html +=
      "<p>в количестве " +
      fill(pages, "__") +
      " листов, подтверждаю, что в представленных материалах, предназначенных для " +
      fill(
        fullPurpose,
        "опубликования в журнале (указать название журнала и название издательства), сборнике тезисов/материалов конференции (указать полное название конференции), представления к защите в диссертационный совет и т.п."
      ) +
      "</p>";
    html +=
      "<p>не содержится сведений, составляющих государственную тайну, служебную или коммерческую тайну, препятствующих открытой публикации.</p>";
    html +=
      "<p>Сообщаю, что мне известно о персональной ответственности автора за разглашение сведений, составляющих государственную тайну, подлежащих защите законами РФ о защите объектов интеллектуальной собственности.</p>";
    html +=
      "<p>В предлагаемом к опубликованию тексте нет данных по незащищённым объектам интеллектуальной собственности других авторов.</p>";
    html +=
      "<p>Согласен на использование результатов своей работы безвозмездно в АНОО ВО «Университет «Сириус»» для учебного процесса.</p>";

    html += '<div style="margin-top:25px;">';
    html +=
      '<div class="ez-sign-line"><div>Автор ____________________ ' +
      fill(fio, "Ф.И.О.") +
      "</div></div>";

    if (isStudent) {
      html +=
        '<div class="ez-sign-line" style="margin-top:18px;"><div>Научный руководитель ____________________ ' +
        fill(supervisorFio, "Ф.И.О. руководителя") +
        "</div></div>";
    }

    html +=
      '<p style="margin-top:20px;">«' +
      (dateStr || '<span class="ez-empty">дата не указана</span>') +
      "»</p>";
    html += "</div>";

    return html;
  }

  function generate() {
    setDocHtml(buildDoc());
  }

  function printDoc() {
    if (!docHtml) {
      alert("Сначала сформируйте справку!");
      return;
    }
    printHtml(docRef.current ? docRef.current.innerHTML : docHtml);
  }

  function copyText() {
    if (!docHtml || !docRef.current) {
      alert("Сначала сформируйте справку!");
      return;
    }
    const clone = docRef.current.cloneNode(true);
    clone.querySelectorAll(".ez-empty").forEach((el) => {
      el.textContent = "__________";
    });
    const finalText = clone.innerText.trim();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(finalText)
        .then(() => alert("Текст скопирован!"))
        .catch(() => fallbackCopy(finalText));
    } else {
      fallbackCopy(finalText);
    }
  }

  function fallbackCopy(text) {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
    alert("Текст скопирован!");
  }

  // Формирование и скачивание реального .docx (Times New Roman 14pt, 1.5
  // интервал, выравнивание по ширине) — библиотека docx подгружается лениво.
  async function downloadDocx() {
    let lib;
    try {
      lib = await ensureDocx();
    } catch (e) {
      alert("Не удалось загрузить библиотеку для создания .docx");
      return;
    }
    const { Document, Packer, Paragraph, TextRun, AlignmentType } = lib;
    const { fullMaterial, fullPurpose, dateStr } = deriveFields();

    const fontProps = { font: "Times New Roman", size: 28 };
    const LONG = "________________________________________________________";
    const NAME = "_______________________";
    const empty = () => new Paragraph({ children: [] });
    const body = (text) =>
      new Paragraph({
        children: [new TextRun({ text, ...fontProps })],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { line: 360 },
      });

    const children = [
      new Paragraph({
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "Авторская справка",
            bold: true,
            size: 28,
            font: "Times New Roman",
          }),
        ],
        spacing: { after: 200 },
      }),
      empty(),
      body("Я, " + (fio || NAME) + ", автор " + (fullMaterial || LONG)),
      body(
        "в количестве " +
          (pages || "___") +
          " листов, подтверждаю, что в представленных материалах, предназначенных для " +
          (fullPurpose || LONG)
      ),
      body(
        "не содержится сведений, составляющих государственную тайну, служебную или коммерческую тайну, препятствующих открытой публикации."
      ),
      empty(),
      body(
        "Сообщаю, что мне известно о персональной ответственности автора за разглашение сведений, составляющих государственную тайну, подлежащих защите законами РФ о защите объектов интеллектуальной собственности."
      ),
      body(
        "В предлагаемом к опубликованию тексте нет данных по незащищённым объектам интеллектуальной собственности других авторов."
      ),
      body(
        "Согласен на использование результатов своей работы безвозмездно в АНОО ВО «Университет «Сириус»» для учебного процесса."
      ),
      empty(),
      new Paragraph({
        children: [
          new TextRun({
            text: "Автор  ______________________________  " + (fio || NAME),
            ...fontProps,
          }),
        ],
        alignment: AlignmentType.LEFT,
        spacing: { before: 600, after: 200, line: 360 },
      }),
      ...(isStudent
        ? [
            new Paragraph({
              children: [
                new TextRun({
                  text:
                    "Научный руководитель  ______________________________  " +
                    (supervisorFio || NAME),
                  ...fontProps,
                }),
              ],
              alignment: AlignmentType.LEFT,
              spacing: { before: 400, after: 100, line: 360 },
            }),
          ]
        : []),
      new Paragraph({
        children: [
          new TextRun({ text: "«" + (dateStr || "___") + "»", ...fontProps }),
        ],
        alignment: AlignmentType.LEFT,
        spacing: { before: 400, line: 360 },
      }),
    ];

    const doc = new Document({
      styles: {
        default: {
          document: {
            run: fontProps,
            paragraph: {
              spacing: { line: 360 },
              alignment: AlignmentType.JUSTIFIED,
            },
          },
        },
      },
      sections: [
        {
          properties: {
            page: {
              margin: { top: 1000, bottom: 1000, left: 1500, right: 1500 },
            },
          },
          children,
        },
      ],
    });

    Packer.toBlob(doc)
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Авторская_справка.docx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error(err);
        alert("Ошибка при создании файла .docx");
      });
  }

  return (
    <div className="App">
      <NaviBarv2 />

      <style>{`
        .ez-doc {
          background: #fffefb;
          border: 1px solid #ccc;
          padding: 35px 30px;
          min-height: 480px;
          font-family: Georgia, "Times New Roman", serif;
          font-size: 14px;
          line-height: 1.8;
          color: #1a1a1a;
        }
        .ez-doc .ez-title { text-align: center; font-weight: 700; font-size: 16px; margin-bottom: 20px; }
        .ez-doc p { margin: 0 0 14px 0; text-align: justify; }
        .ez-doc .ez-fill { border-bottom: 1px solid #666; padding: 0 4px; font-weight: 500; }
        .ez-doc .ez-empty { border-bottom: 1px solid #999; padding: 0 4px; color: #b8382f; }
        .ez-doc .ez-sign-line { display: flex; justify-content: space-between; margin-top: 15px; }
        .ez-doc .ez-sign-label { font-size: 11px; color: #777; margin-top: 2px; }
        .ez-doc-empty { color: #999; font-style: italic; text-align: center; padding: 60px 0; }
      `}</style>

      <Container className="py-4 text-start">
        {/* Заголовок */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-2">
            Получение Экспертного заключения (ЭЗ)
          </h1>
          <p className="text-muted mb-2">
            АНОО ВО «Университет «Сириус» — экспертиза материалов, предназначенных
            к открытому опубликованию, и генератор авторской справки
          </p>
          <Badge bg="success" className="fs-6 px-3 py-2">
            Экспертное заключение (ЭЗ)
          </Badge>
        </div>

        {/* Процесс */}
        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Получение экспертного заключения
          </h2>
          <Row className="g-3">
            {EZ_STEPS.map((s) => (
              <Col key={s.n} md={6} lg={4}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body>
                    {s.deadline && (
                      <div
                        className="small text-uppercase mb-1"
                        style={{ color: "#b5720c", letterSpacing: "0.06em" }}
                      >
                        {s.deadline}
                      </div>
                    )}
                    <div style={numStyle(s.branch)}>{s.n}</div>
                    <h3 className="h6 fw-bold">{s.title}</h3>
                    <p className="text-muted small mb-0">{s.text}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* Важно помнить */}
        <section className="mb-5">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h3 className="h5 fw-bold" style={{ color: ACCENT }}>
                Важно помнить
              </h3>
              <ul className="text-muted mb-0">
                <li>
                  Вид материала (статья / тезисы / презентационный материал)
                  указывается в справке.
                </li>
                <li>Название должно совпадать в справке и в самих материалах.</li>
                <li>
                  Материал на иностранном языке — в справке указывается название
                  на иностр. и на рус. языках, прилагается абстракт
                  (реферат)/тезисы на русском.
                </li>
                <li>
                  Если авторы — только обучающиеся, справку подписывает
                  обучающийся и его научный руководитель.
                </li>
                <li>
                  Если материалы после подготовки ЭЗ существенно менялись по сути
                  — требуется повторная экспертиза.
                </li>
              </ul>
            </Card.Body>
          </Card>
        </section>

        {/* Генератор авторской справки */}
        <section className="mb-4">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Генератор авторской справки
          </h2>
          <Row className="g-4">
            {/* Левая панель — форма */}
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h3
                    className="h5 fw-bold mb-3 pb-2"
                    style={{ borderBottom: `2px solid ${ACCENT}` }}
                  >
                    Заполните все поля
                  </h3>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">
                      Ф.И.О. автора
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Иванов Иван Иванович"
                      value={fio}
                      onChange={(e) => setFio(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="ez-isStudent"
                    label="Автор — обучающийся"
                    checked={isStudent}
                    onChange={(e) => setIsStudent(e.target.checked)}
                  />

                  {isStudent && (
                    <Form.Group
                      className="mb-3 ps-3"
                      style={{ borderLeft: `3px solid ${ACCENT}` }}
                    >
                      <Form.Label className="fw-semibold small">
                        Ф.И.О. научного руководителя
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Петров Пётр Петрович"
                        value={supervisorFio}
                        onChange={(e) => setSupervisorFio(e.target.value)}
                      />
                    </Form.Group>
                  )}

                  <Row>
                    <Col xs={7}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Вид материала
                        </Form.Label>
                        <Form.Select
                          value={materialType}
                          onChange={(e) => setMaterialType(e.target.value)}
                        >
                          <option value="статьи">Статьи</option>
                          <option value="тезисов">Тезисов</option>
                          <option value="презентационного материала">
                            Презентационного материала
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={5}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Кол-во листов
                        </Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          placeholder="12"
                          value={pages}
                          onChange={(e) => setPages(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">
                      Название материала (рус./англ.)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Название"
                      value={titleRu}
                      onChange={(e) => setTitleRu(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id="ez-isForeign"
                    label="Материал на иностранном языке/перевод"
                    checked={isForeign}
                    onChange={(e) => setIsForeign(e.target.checked)}
                  />

                  {isForeign && (
                    <Form.Group
                      className="mb-3 ps-3"
                      style={{ borderLeft: `3px solid ${ACCENT}` }}
                    >
                      <Form.Label className="fw-semibold small">
                        Название на иностранном языке/перевод
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Title in English"
                        value={titleEn}
                        onChange={(e) => setTitleEn(e.target.value)}
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">Назначение</Form.Label>
                    <Form.Select
                      value={purposeType}
                      onChange={(e) => setPurposeType(e.target.value)}
                    >
                      <option value="журнал">Опубликование в журнале</option>
                      <option value="конференция">
                        Сборник тезисов конференции
                      </option>
                      <option value="диссовет">Диссертационный совет</option>
                      <option value="иное">Иное</option>
                    </Form.Select>
                  </Form.Group>

                  {purposeType === "журнал" ? (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Название журнала
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Журнал Наука"
                          value={purposeDetail}
                          onChange={(e) => setPurposeDetail(e.target.value)}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold small">
                          Название издательства
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Издательство"
                          value={publisher}
                          onChange={(e) => setPublisher(e.target.value)}
                        />
                      </Form.Group>
                    </>
                  ) : (
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold small">
                        {PURPOSE_DETAIL_LABEL[purposeType]}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Уточнение"
                        value={purposeDetail}
                        onChange={(e) => setPurposeDetail(e.target.value)}
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold small">
                      Дата подписания
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={signDate}
                      onChange={(e) => setSignDate(e.target.value)}
                    />
                  </Form.Group>

                  <Button variant="success" className="w-100 fw-bold" onClick={generate}>
                    📄 Сформировать справку
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            {/* Правая панель — готовая справка */}
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body>
                  <h3
                    className="h5 fw-bold mb-3 pb-2"
                    style={{ borderBottom: `2px solid ${ACCENT}` }}
                  >
                    Готовая справка
                  </h3>
                  {docHtml ? (
                    <div
                      className="ez-doc"
                      ref={docRef}
                      dangerouslySetInnerHTML={{ __html: docHtml }}
                    />
                  ) : (
                    <div className="ez-doc">
                      <div className="ez-doc-empty">
                        Заполните поля слева и нажмите
                        <br />
                        <strong>«Сформировать справку»</strong>
                      </div>
                    </div>
                  )}
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={copyText}
                    >
                      📋 Скопировать текст
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={printDoc}
                    >
                      🖨️ Печать / PDF
                    </Button>
                    <Button
                      size="sm"
                      onClick={downloadDocx}
                      style={{
                        backgroundColor: "#1b2a4a",
                        borderColor: "#1b2a4a",
                        color: "#fff",
                      }}
                    >
                      ⬇️ Скачать .docx
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </section>
      </Container>

      <Footer />
    </div>
  );
}

export default ExpertReview;
